<template>
  <div
    class="input-field"
    :class="{'error': validationError}"
  >
    <label v-if="label">{{ label }}</label>

    <div
      class="relative flex flex-col"
      @click="triggerColorPicker"
    >
      <ColourPreview
        :colour="model"
        class="cursor-pointer w-48 font-medium flex-row-reverse justify-between pl-2 mb-0 border-gray-300"
      />

      <input
        ref="colorInput"
        v-model="model"
        type="color"
        :required="required"
        class="invisible -mt-4"
      >
    </div>

    <span
      v-if="validationError"
      class="validation-error-message"
    >
      {{ validationError }}
    </span>
  </div>
</template>

<script setup>
import { ref } from 'vue';

import { ColourPreview } from '@/components/goal';

defineProps({
  label: {
    type: String,
    default: null,
  },
  required: {
    type: Boolean,
    default: false,
  },
  focus: {
    type: Boolean,
    default: false,
  },
  validationError: {
    type: Object,
    default: () => null,
  },
});

const model = defineModel();
const colorInput = ref(null);

const triggerColorPicker = () => {
  colorInput.value.click();
};

</script>
